(function (angular) {
    'use strict';

    angular.module('channels')

        /**
         *
         */
        .factory('whatsAppChannelService',
            ['$uibModal', '$stateParams', '$http', 'portalConfig', 'facebookService', 'growlService', 'whatsAppServices', '$rootScope',
                function ($uibModal, $stateParams, $http, portalConfig, facebookService, growlService, whatsAppServices, $rootScope) {

                    var urlBase = portalConfig.urlBase;
                    var fac = {
                        getCloudConfiguration: getCloudConfiguration,
                        launchWhatsAppSignupForm: launchWhatsAppSignupForm,
                        // On Premise methods
                        getBusinessProfileConfig: getBusinessProfileConfig,
                        verifyPhone: verifyPhone,
                        getHsms: getHsms
                    };

                    window.addEventListener('message', handleSessionInfo);

                    return fac;

                    function getCloudConfiguration(params, secondParams) {
                        return $uibModal.open({
                            templateUrl: 'components/channels/whatsApp/templates/cloudConfiguration.html',
                            size: 'lg',
                            resolve: {
                                whatsAppConfig: function () {
                                    return secondParams ? secondParams : params;
                                }
                            },
                            controller: 'whatsAppCloudConfigurationController'
                        });
                    }

                    // Calls api endpoint to save WA config
                    function saveWhatsAppConfig(apiSpaceId, config) {
                        $http.post(`${urlBase}/apispaces/${apiSpaceId}/channels/whatsapp/cloud`, config)
                            .then(function (response) {
                                growlService.success('WhatsApp Business API successfully configured');
                                $rootScope.$broadcast('WhatsApp channel created', response.data);
                            })
                            .catch(function (error) {
                                if (error.status === 409) {
                                    whatsAppServices.getWhatsAppCloudConfigurations($stateParams.pickedApiSpaceId, [config.wabaId]).then(function (response) {
                                        const existingConfig = response.find(item => item.phoneNumberId === config.phoneNumberId);
                                        growlService.danger(`The phone number is already linked to the business account "${existingConfig.wabaName}" (ID: ${config.wabaId})`);
                                    });

                                } else {
                                    growlService.danger(`WhatsApp Business API configuration failed: ${error.statusText}`);
                                }
                            });
                    }

                    function loadSdkAsync() {
                        return new Promise((resolve, reject) => {
                            ((doc, elementType, elementId) => {
                                let targetScriptElement = doc.getElementsByTagName(elementType)[0];

                                if (doc.getElementById(elementId))
                                    resolve();

                                let facebookSdkScript = doc.createElement(elementType);
                                facebookSdkScript.id = elementId;
                                facebookSdkScript.onload = () => {
                                    resolve();
                                };
                                facebookSdkScript.src = 'https://connect.facebook.net/en_US/sdk.js';

                                targetScriptElement.parentNode.insertBefore(facebookSdkScript, targetScriptElement);
                            })(document, 'script', 'facebook-jssdk')
                        });
                    }

                    // Initiates the Facebook login process with the required permissions and options
                    async function launchWhatsAppSignupForm() {
                        await loadSdkAsync();
                        let metaAppId = await facebookService.getAppId($stateParams.pickedApiSpaceId);

                        window.FB.init({
                            appId: metaAppId,
                            xfbml: true,
                            cookie: true,
                            version: portalConfig.fbApiVersion
                        });

                        window.FB.login(
                            function (response) {
                                if (!response.authResponse?.accessToken) {
                                    // User cancelled login or did not fully authorize
                                    growlService.danger("Login cancelled or not fully authorized");
                                }
                            },
                            {
                                scope: 'whatsapp_business_management, whatsapp_business_messaging',
                                extras: {
                                    feature: 'whatsapp_embedded_signup',
                                    version: 2,
                                    /*featureType: 'only_waba_sharing', // Bypass phone number selection*/
                                    sessionInfoVersion: 2
                                }
                            }
                        );
                    }

                    /**
                     * Handles the 'message' event raised by the Facebook login process after
                     * completing the WhatsApp Business API sign-up form.
                     * The event listener is added in the constructor.
                     **/
                    function handleSessionInfo(event) {
                        if (!event.origin.includes('facebook.com')) return;
                        let data;
                        try {
                            data = JSON.parse(event.data);
                        }
                        catch {
                            // Some Facebook events are sent as query string, not JSON
                            return;
                        }

                        if (data.type === 'WA_EMBEDDED_SIGNUP') {
                            if (data.event === 'FINISH') {
                                const { phone_number_id, waba_id } = data.data;

                                saveWhatsAppConfig($stateParams.pickedApiSpaceId, {
                                    phoneNumberId: phone_number_id,
                                    wabaId: waba_id
                                });
                            }
                        }
                    }

                    // On Premise methods
                    function getBusinessProfileConfig(params, secondParams) {
                        return $uibModal.open({
                            templateUrl: 'components/channels/whatsApp/templates/businessProfileConfig.html',
                            size: 'lg',
                            resolve: {
                                whatsAppConfig: function () {
                                    return secondParams ? secondParams : params;
                                }
                            },
                            controller: 'whatsAppBusinessProfileController'
                        });
                    }
                    function getHsms() {
                        return $uibModal.open({
                            templateUrl: 'components/channels/whatsApp/templates/hsms.html',
                            size: 'lg',
                            resolve: {
                                hsmsData: ['$q', '$stateParams', 'whatsAppServices', function ($q, $stateParams, whatsAppServices) {
                                    return whatsAppServices.getHsms($stateParams.pickedApiSpaceId)
                                        .then(function (result) {
                                            return result;
                                        }).catch(function (result) {
                                            var deferred = $q.defer();
                                            if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                            return deferred.promise;
                                        });
                                }],
                            },
                            controller: 'whatsAppHsmController'
                        });
                    }
                    function verifyPhone(params) {
                        return $uibModal.open({
                            templateUrl: 'components/channels/whatsApp/templates/verifyPhone.html',
                            size: 'md',
                            resolve: {
                                phoneNumber: function () {
                                    return params.phoneNumber;
                                }
                            },
                            controller: 'whatsAppVerifyPhoneController'
                        });
                    }

                }]);

})(window.angular);